// /* Scheme List */
export const SCHEMES_ANALYTES = "SCHEMES_ANALYTES";
export const SCHEMES_ANALYTES_SUCCESS = "SCHEMES_ANALYTES_SUCCESS";
export const SCHEMES_ANALYTES_FAIL = "SCHEMES_ANALYTES_FAIL";

export const POST_RESULT = "POST_RESULT";
export const POST_RESULT_SUCCESS = "POST_RESULT_SUCCESS";
export const POST_RESULT_FAIL = "POST_RESULT_FAIL";

export const UPDATE_RESULT = "UPDATE_RESULT";
export const UPDATE_RESULT_SUCCESS = "UPDATE_RESULT_SUCCESS";
export const UPDATE_RESULT_FAIL = "UPDATE_RESULT_FAIL";

export const GET_RESULT = "GET_RESULT";
export const GET_RESULT_SUCCESS = "GET_RESULT_SUCCESS";
export const GET_RESULT_FAIL = "GET_RESULT_FAIL";

export const GET_STATISTICS = "GET_STATISTICS";
export const GET_STATISTICS_SUCCESS = "GET_STATISTICS_SUCCESS";
export const GET_STATISTICS_FAIL = "GET_STATISTICS_FAIL";

export const POST_SERELOGY_VALUES = "POST_SERELOGY_VALUES";
export const POST_SERELOGY_VALUES_SUCCESS = "POST_SERELOGY_VALUES_SUCCESS";
export const POST_SERELOGY_VALUES_FAIL = "POST_SERELOGY_VALUES_FAIL";

export const GET_SERELOGY_VALUES = "GET_SERELOGY_VALUES";
export const GET_SERELOGY_VALUES_SUCCESS = "GET_SERELOGY_VALUES_SUCCESS";
export const GET_SERELOGY_VALUES_FAIL = "GET_SERELOGY_VALUES_FAIL";

export const GET_ANALYTE_RESULT_PARTICIPANT = "GET_ANALYTE_RESULT_PARTICIPANT";
export const GET_ANALYTE_RESULT_PARTICIPANT_SUCCESS =
  "GET_ANALYTE_RESULT_PARTICIPANT_SUCCESS";
export const GET_ANALYTE_RESULT_PARTICIPANT_FAIL =
  "GET_ANALYTE_RESULT_PARTICIPANT_FAIL";

export const GET_MICRO_RESULT_DATA = "GET_MICRO_RESULT_DATA";
export const GET_MICRO_RESULT_DATA_SUCCESS = "GET_MICRO_RESULT_DATA_SUCCESS";
export const GET_MICRO_RESULT_DATA_FAIL = "GET_MICRO_RESULT_DATA_FAIL";

export const POST_MICRO_RESULT = "POST_MICRO_RESULT";
export const POST_MICRO_RESULT_SUCCESS = "POST_MICRO_RESULT_SUCCESS";
export const POST_MICRO_RESULT_FAIL = "POST_MICRO_RESULT_FAIL";

export const GET_MICRO_VALUE_LIST = "GET_MICRO_VALUE_LIST";
export const GET_MICRO_VALUE_LIST_SUCCESS = "GET_MICRO_VALUE_LIST_SUCCESS";
export const GET_MICRO_VALUE_LIST_FAIL = "GET_MICRO_VALUE_LIST_FAIL";

export const POST_MICRO_VALUE = "POST_MICRO_VALUE";
export const POST_MICRO_VALUE_SUCCESS = "POST_MICRO_VALUE_SUCCESS";
export const POST_MICRO_VALUE_FAIL = "POST_MICRO_VALUE_FAIL";

export const GET_MICRO_STATISTICS = "GET_MICRO_STATISTICS";
export const GET_MICRO_STATISTICS_SUCCESS = "GET_MICRO_STATISTICS_SUCCESS";
export const GET_MICRO_STATISTICS_FAIL = "GET_MICRO_STATISTICS_FAIL";

export const GET_ANALYTE_DATA = "GET_ANALYTE_DATA";
export const GET_ANALYTE_DATA_SUCCESS = "GET_ANALYTE_DATA_SUCCESS";
export const GET_ANALYTE_DATA_FAIL = "GET_ANALYTE_DATA_FAIL";

export const GET_RESULT_ANALYTE_DATA = "GET_RESULT_ANALYTE_DATA";
export const GET_RESULT_ANALYTE_DATA_SUCCESS =
  "GET_RESULT_ANALYTE_DATA_SUCCESS";
export const GET_RESULT_ANALYTE_DATA_FAIL = "GET_RESULT_ANALYTE_DATA_FAIL";

export const UPDATE_MICRO_RESULT = "UPDATE_MICRO_RESULT";
export const UPDATE_MICRO_RESULT_SUCCESS = "UPDATE_MICRO_RESULT_SUCCESS";
export const UPDATE_MICRO_RESULT_FAIL = "UPDATE_MICRO_RESULT_FAIL";

export const GET_QUALITATIVE_ASSIGN = "GET_QUALITATIVE_ASSIGN";
export const GET_QUALITATIVE_ASSIGN_SUCCESS = "GET_QUALITATIVE_ASSIGN_SUCCESS";
export const GET_QUALITATIVE_ASSIGN_FAIL = "GET_QUALITATIVE_ASSIGN_FAIL";

export const SAVE_STATISTICS_STATUS_REQUEST = "SAVE_STATISTICS_STATUS_REQUEST";
export const SAVE_STATISTICS_STATUS_SUCCESS = "SAVE_STATISTICS_STATUS_SUCCESS";
export const SAVE_STATISTICS_STATUS_FAILURE = "SAVE_STATISTICS_STATUS_FAILURE";
